import i18n from "i18next";
import { initReactI18next } from "react-i18next";

  const resources = {
  en: {
    translation: {
      aboutAlt: "Creative video design process",
      aboutSubtitle: "ABOUT US",
      aboutTitle: "We Bring Your Ideas to Life Through Stunning Web Videos",
      aboutDescription: "At INITIALS, we specialize in crafting eye-catching video content that connects with your audience and drives results. From concept to final delivery, we focus on quality, creativity, and impact.",
      aboutPoint1: "Custom-made designs tailored to your brand",
      aboutPoint2: "Engaging motion graphics and animations",
      downloadBtn: "Download Company Profile"
    }
  },
  ar: {
    translation: {
      aboutAlt: "عملية تصميم الفيديو الإبداعية",
      aboutSubtitle: "معلومات عنا",
      aboutTitle: "نحوّل أفكارك إلى واقع من خلال فيديوهات ويب مذهلة",
      aboutDescription: "في INITIALS، نحن متخصصون في إنشاء محتوى فيديو لافت يجذب جمهورك ويحقق النتائج. من الفكرة إلى التسليم النهائي، نركز على الجودة والإبداع والتأثير.",
      aboutPoint1: "تصاميم مخصصة تلائم علامتك التجارية",
      aboutPoint2: "رسوم متحركة وجرافيك مشوقة",
      downloadBtn: "تحميل الملف التعريفي للشركة"
    }
  },
  hi: {
    translation: {
      aboutAlt: "क्रिएटिव वीडियो डिज़ाइन प्रक्रिया",
      aboutSubtitle: "हमारे बारे में",
      aboutTitle: "हम शानदार वेब वीडियो के माध्यम से आपके विचारों को जीवन देते हैं",
      aboutDescription: "INITIALS में, हम ऐसा आकर्षक वीडियो कंटेंट बनाते हैं जो आपके दर्शकों को जोड़ता है और परिणाम देता है। विचार से लेकर अंतिम डिलीवरी तक, हम गुणवत्ता, रचनात्मकता और प्रभाव पर ध्यान देते हैं।",
      aboutPoint1: "आपके ब्रांड के अनुसार कस्टम डिज़ाइन",
      aboutPoint2: "दिलचस्प मोशन ग्राफिक्स और एनिमेशन",
      downloadBtn: "कंपनी प्रोफ़ाइल डाउनलोड करें"
    }
  },
  fr: {
    translation: {
      aboutAlt: "Processus créatif de conception vidéo",
      aboutSubtitle: "À PROPOS",
      aboutTitle: "Nous donnons vie à vos idées grâce à des vidéos web époustouflantes",
      aboutDescription: "Chez INITIALS, nous créons du contenu vidéo accrocheur qui capte votre audience et produit des résultats. De l'idée à la livraison finale, nous mettons l'accent sur la qualité, la créativité et l'impact.",
      aboutPoint1: "Designs personnalisés adaptés à votre marque",
      aboutPoint2: "Graphismes et animations engageants",
      downloadBtn: "Télécharger la présentation"
    }
  }
};


i18n.use(initReactI18next).init({
  resources,
  lng: "en", // default language
  fallbackLng: "en",
  interpolation: { escapeValue: false }
});

export default i18n;
